/**
 * Pre-compiled de messages for Alert
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { dismiss: `Verwerfen` };
